import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  LBRDUUERNewDataUpdateRequestControlName,
  LBRDUUERNewDataUpdateRequestFormGroup,
} from './new-data-update-request-form.model';

@Injectable()
export class LBRDUUERNewDataUpdateRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<LBRDUUERNewDataUpdateRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [LBRDUUERNewDataUpdateRequestControlName.ProxyDetailsCheckbox]: false,
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [LBRDUUERNewDataUpdateRequestControlName.ChangeScope]: [
        '',
        [Validators.required],
      ],
      [LBRDUUERNewDataUpdateRequestControlName.DeterminationOfLocation]: [''],
    });
  }
}
